export const APP_INFO = {
  NAME: 'TurnItBlue',
};

export const TENANT_NAME = {
  TIB: 'TIB',
  TBD: 'TBD',
  REACHRIGHTADS: 'REACHRIGHTADS',
  CONQUESTDSP: 'CONQUESTDSP',
};

export const VIEW_MODE = {
  GRID: 1,
  LIST: 2,
};

export const SORT_BY_TIME = [
  {
    id: 'Newest',
    name: 'Newest',
  },
  {
    id: 'Oldest',
    name: 'Oldest',
  },
];

export const PASSWORD_PATTERN = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*\W)[\w\W]{8,}$/; // Minimum 8 characters, at least one special character, one letter and one number
export const PHONE_PATTERN = /^([0-9])+([0-9]{7,20})\b$/;
export const SUBDOMAIN_PATTERN = /^[a-zA-Z0-9][a-zA-Z0-9_-]+[a-zA-Z0-9]$/;
export const DOMAIN_PATTERN =
  /^(https:\/\/|http:\/\/)(((([a-zA-Z0-9])|([a-zA-Z0-9][a-zA-Z0-9\-]{0,86}[a-zA-Z0-9]))\.(([a-zA-Z0-9])|([a-zA-Z0-9][a-zA-Z0-9\-]{0,73}[a-zA-Z0-9]))\.(([a-zA-Z0-9]{2,12}\.[a-zA-Z0-9]{2,12})|([a-zA-Z0-9]{2,25})))|((([a-zA-Z0-9])|([a-zA-Z0-9][a-zA-Z0-9\-]{0,162}[a-zA-Z0-9]))\.(([a-zA-Z0-9]{2,12}\.[a-zA-Z0-9]{2,12})|([a-zA-Z0-9]{2,25}))))$/gm;

export const CANVA_LINK_PATTERN =
  /^(https:\/\/|http:\/\/)(www.){0,1}(canva+)\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm;

export const DEALID_PATTERN =
  /^[0-9a-fA-F]{8}[0-9a-fA-F]{4}[0-9a-fA-F]{4}[0-9a-fA-F]{4}[0-9a-fA-F]{12}$/; // Minimum 8 characters, at least one special character, one letter and one number

export const FILE_ACCEPT = {
  PDF: 'application/pdf, ',
  DOC: '.doc,.docx, ',
  DOCX: '.docx, ',
  CONTRACT: 'application/pdf',
  XLS: 'application/vnd.ms-excel, ',
  DOCUMENT: 'application/pdf, application/msword, application/vnd.ms-excel',
};

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  NOT_ALLOW: 405,
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
};

export const GENERATE_OTP_ACTIONS = {
  REGISTER: 'Register',
  UPDATE_EMAIL: 'UpdateNewEmail',
  CONFIRM_EMAIL: 'ConfirmOldEmail',
  FORGOT_PASSWORD: 'ForgotPassword',
  RESET_PASSWORD: 'ResetPassword',
};

export const COMMON_STATUS = {
  ACTIVE: 1,
  INACTIVE: 2,
  PENDING: 3,
  APPROVED: 4,
  REJECTED: 5,
};

export const MAP_COMMON_STATUS = {
  Active: COMMON_STATUS.ACTIVE,
  InActive: COMMON_STATUS.INACTIVE,
  Pending: COMMON_STATUS.PENDING,
  PendingInvite: COMMON_STATUS.PENDING,
  Approved: COMMON_STATUS.APPROVED,
  Rejected: COMMON_STATUS.REJECTED,
};

export const USER_ROLES = {
  ADMIN: 'Admin',
  EMPLOYEE: 'Employee',
  USER: 'User',
  INDIVIDUAL: 'Individual',
  MANAGER: 'Manager',
};

export const STATUS = [
  {
    id: 1,
    name: 'Active',
  },
  {
    id: 2,
    name: 'Inactive',
  },
];

export const ROLE_OPTIONS = [
  {
    id: 'admin',
    name: 'Admin',
  },
  {
    id: 'employee',
    name: 'Employee',
  },
];

export const STAFF_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'InActive',
  PENDING_INVITE: 'PendingInvite',
};

export const STAFF_STATUS_OPTIONS = [
  {
    id: null,
    name: 'All',
  },
  {
    id: STAFF_STATUS.ACTIVE,
    name: 'Active',
  },
  {
    id: STAFF_STATUS.INACTIVE,
    name: 'Inactive',
  },
  {
    id: STAFF_STATUS.PENDING_INVITE,
    name: 'Pending Invite',
  },
];

export const CUSTOMER_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'InActive',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  PENDING: 'Pending',
  PENDING_INVITE: 'PendingInvite',
};

export const CUSTOMER_STATUS_OPTIONS = [
  {
    id: null,
    name: 'All',
  },
  {
    id: CUSTOMER_STATUS.ACTIVE,
    name: 'Active',
  },
  {
    id: CUSTOMER_STATUS.INACTIVE,
    name: 'Inactive',
  },
  {
    id: CUSTOMER_STATUS.APPROVED,
    name: 'Approved',
  },
  {
    id: CUSTOMER_STATUS.REJECTED,
    name: 'Rejected',
  },
];

export const SUB_CUSTOMER_STATUS_OPTIONS = [
  {
    id: undefined,
    name: 'All',
  },
  {
    id: CUSTOMER_STATUS.ACTIVE,
    name: 'Active',
  },
  {
    id: CUSTOMER_STATUS.INACTIVE,
    name: 'Inactive',
  },
  { id: CUSTOMER_STATUS.PENDING_INVITE, name: 'Pending Invite' },
];

export const CUSTOMER_ROLE_OPTIONS = [
  {
    id: 'Agency',
    name: 'Agency',
  },
  {
    id: 'Organization',
    name: 'Organization',
  },
  {
    id: 'Campaign',
    name: 'Campaign',
  },
];

export const CUSTOMER_CAMPAIGN_TYPE = [
  {
    id: 'StateHouse',
    name: 'State House',
  },
  {
    id: 'StateSenate',
    name: 'State Senate',
  },
  {
    id: 'Mayoral',
    name: 'Mayoral',
  },
  {
    id: 'CityCouncil',
    name: 'City Council',
  },
  {
    id: 'OtherMunicipal',
    name: 'Other Municipal',
  },
  {
    id: 'UsSenate',
    name: 'Us Senate',
  },
  {
    id: 'UsCongress',
    name: 'Us Congress',
  },
  {
    id: 'OtherStatewide',
    name: 'Other Statewide',
  },
  {
    id: 'NotApplicable',
    name: 'Not Applicable',
  },
];

export const USER_TYPE = {
  PORTAL: 'Portal',
  CUSTOMER: 'Customer',
};

export const CUSTOMER_TABS = {
  WAITING_APPROVAL: 'WAITING_APPROVAL',
  USER_LIST: 'USER_LIST',
};

export const PAYMENT_METHOD_TYPE = {
  CARD: 'Card',
  ACH_ACCOUNT: 'AchAccount',
  PAYMENT: 'Payment',
  TOP_UP: 'TopUp',
  DEDUCT: 'Deduct',
  REFUND: 'Refund',
};

// Mirrors the API PaymentMethodType enum. PAYMENT_METHOD_TYPE above also carries
// transfer types (Payment / TopUp / ...), so it can't be used to tell payment methods apart.
export const PAYMENT_TYPE = {
  CREDIT_CARD: 'Card',
  BANK: 'AchAccount',
  ACCOUNT_BALANCE: 'AccountBalance',
  WIRE_TRANSFER: 'WireTransfer',
  DISCOUNT_CODE: 'DiscountCode',
};

export const PAYMENT_METHOD_TYPE_NAME = {
  [PAYMENT_METHOD_TYPE.CARD]: ' Credit Card',
  [PAYMENT_METHOD_TYPE.ACH_ACCOUNT]: 'ACH Account',
  [PAYMENT_METHOD_TYPE.PAYMENT]: 'Payment',
  [PAYMENT_METHOD_TYPE.TOP_UP]: 'Top-up',
  [PAYMENT_METHOD_TYPE.DEDUCT]: 'Deduct',
  [PAYMENT_METHOD_TYPE.REFUND]: 'Refund',
};

export const WALLET_TRANSACTION_TRANSFER_TYPE = [
  {
    id: PAYMENT_METHOD_TYPE.TOP_UP,
    name: PAYMENT_METHOD_TYPE_NAME[PAYMENT_METHOD_TYPE.TOP_UP],
  },
  {
    id: PAYMENT_METHOD_TYPE.PAYMENT,
    name: PAYMENT_METHOD_TYPE_NAME[PAYMENT_METHOD_TYPE.PAYMENT],
  },
  {
    id: PAYMENT_METHOD_TYPE.DEDUCT,
    name: PAYMENT_METHOD_TYPE_NAME[PAYMENT_METHOD_TYPE.DEDUCT],
  },
  {
    id: PAYMENT_METHOD_TYPE.REFUND,
    name: PAYMENT_METHOD_TYPE_NAME[PAYMENT_METHOD_TYPE.REFUND],
  },
];

export const CUSTOMER_DETAIL_TABS = {
  general_info: { key: 'general_info', title: 'General Information' },
  user_list: { key: 'user_list', title: 'List Sub-Users' },
  campaign: { key: 'campaign', title: 'Campaign' },
  wallet_credits: { key: 'wallet_credits', title: 'Wallet Credits' },
};

export const CARD_TYPES = {
  VISA: 'visa',
  MASTER: 'master',
};

export const MONTH_IN_TEXT = {
  1: 'Jan',
  2: 'Feb',
  3: 'Mar',
  4: 'Apr',
  5: 'May',
  6: 'Jun',
  7: 'Jul',
  8: 'Aug',
  9: 'Sep',
  10: 'Oct',
  11: 'Nov',
  12: 'Dec',
};

export const USER_LEVEL = {
  ADMIN: 'Admin',
  ANALYTIC_MANAGER: 'AnalyticManager',
  CAMPAIGN_MANAGER: 'CampaignManager',
};

export const USER_LEVEL_OPTIONS = {
  [USER_LEVEL.ADMIN]: { id: USER_LEVEL.ADMIN, name: 'Admin' },
  [USER_LEVEL.ANALYTIC_MANAGER]: {
    id: USER_LEVEL.ANALYTIC_MANAGER,
    name: 'Analytic Manager',
  },
  [USER_LEVEL.CAMPAIGN_MANAGER]: {
    id: USER_LEVEL.CAMPAIGN_MANAGER,
    name: 'Campaign Manager',
  },
};

export const DATE_ACTIONS = {
  START: 'start',
  END: 'end',
};

export const FIRST_ADS_BUY_TIME = [
  {
    id: 'Immediately',
    name: 'Immediately',
  },
  {
    id: 'Within the next day or so',
    name: 'Within the next day or so',
  },
  {
    id: 'This week',
    name: 'This week',
  },
  {
    id: 'This month',
    name: 'This month',
  },
  {
    id: `Not sure, I'm just testing the waters for now`,
    name: `Not sure, I'm just testing the waters for now`,
  },
];

export const AD_TYPES = {
  MEDIUM_RECTANGLE: '300x250',
  LEADERBOARD: '728x90',
  HALF_PAGE: '300x600',
  BILLBOARD: '970x250',
  WIDE_SKYCRAPER: '160x600',
  MOBILE_LEADERBOARD: '320x50',
};

export const AD_TYPES_OBJ = {
  [AD_TYPES.MEDIUM_RECTANGLE]: {
    id: AD_TYPES.MEDIUM_RECTANGLE,
    name: 'Medium Rectangle',
    className: 'medium-rectangle',
  },
  [AD_TYPES.LEADERBOARD]: {
    id: AD_TYPES.LEADERBOARD,
    name: 'Leaderboard',
    className: 'leaderboard',
  },
  [AD_TYPES.HALF_PAGE]: {
    id: AD_TYPES.HALF_PAGE,
    name: 'Half Page Ad',
    className: 'hafl-page-ad',
  },
  [AD_TYPES.BILLBOARD]: {
    id: AD_TYPES.BILLBOARD,
    name: 'Billboard',
    className: 'billboard',
  },
  [AD_TYPES.WIDE_SKYCRAPER]: {
    id: AD_TYPES.WIDE_SKYCRAPER,
    name: 'Wide Skycraper',
    className: 'wide-skycraper',
  },
  [AD_TYPES.MOBILE_LEADERBOARD]: {
    id: AD_TYPES.MOBILE_LEADERBOARD,
    name: 'Mobile Leaderboard',
    className: 'mobile-leaderboard',
  },
};

export const VIEW_REPORT_TYPES = {
  DATE: 'Date',
  MONTH: 'Month',
};

export const VIEW_REPORT_OPTIONS = [
  {
    id: VIEW_REPORT_TYPES.DATE,
    name: 'Day',
  },
  {
    id: VIEW_REPORT_TYPES.MONTH,
    name: 'Month',
  },
];

export const USER_LEVEL_TYPE = {
  ADMIN: 'Admin',
  CAMPAIGN_MANAGER: 'CampaignManager',
  ANALYTIC_MANAGER: 'AnalyticManager',
};

export const USER_ROLE_TYPES = {
  AGENCY: 'Agency',
  ORGANIZATION: 'Organization',
  CAMPAIGN: 'Campaign',
};

export const CODE_TYPES = {
  DISCOUNT: 'discount',
  VOUCHER: 'voucher',
};

export const CODE_STATUS = {
  ACTIVE: 'active',
  EXPIRED: 'expired',
  SCHEDULED: 'scheduled',
  INACTIVE: 'inactive',
};

export const CODE_STATUS_OPTIONS = [
  {
    id: undefined,
    name: 'All',
  },
  {
    id: 0,
    name: 'Active',
  },
  {
    id: 1,
    name: 'Scheduled',
  },
  {
    id: 2,
    name: 'Expired',
  },
  {
    id: 3,
    name: 'InActive',
  },
];

export const BANNER_TEMPLATE_LENGTH = 6;

export const CAMPAIGN_STATUS = {
  DRAFT: 'Draft',
  RUNNING: 'Running',
  COMPLETED: 'Completed',
  ARCHIVED: 'Archived',
  PAUSE: 'Pause',
  WAITING_FOR_PAYMENT: 'WaitingForPayment',
  PAYMENT_FAILED: 'PaymentFailed',
  PROCESSING: 'Processing',
  PROCESSING_FAILED: 'ProcessingFailed',
};

export const CAMPAIGN_STATUS_OPTIONS = [
  {
    id: CAMPAIGN_STATUS.RUNNING,
    name: 'Running',
  },
  {
    id: CAMPAIGN_STATUS.COMPLETED,
    name: 'Completed',
  },
  {
    id: CAMPAIGN_STATUS.ARCHIVED,
    name: 'Archived',
  },
  {
    id: CAMPAIGN_STATUS.PAUSE,
    name: 'Pause',
  },
  {
    id: CAMPAIGN_STATUS.WAITING_FOR_PAYMENT,
    name: 'Waiting for Payment',
  },
  {
    id: CAMPAIGN_STATUS.PAYMENT_FAILED,
    name: 'Payment Failed',
  },
  {
    id: CAMPAIGN_STATUS.PROCESSING,
    name: 'Processing',
  },
  {
    id: CAMPAIGN_STATUS.PROCESSING_FAILED,
    name: 'Processing Failed',
  },
];

export const ACCOUNT_TYPE_OPTIONS = [
  {
    id: 'Agency',
    name: 'Agency',
  },
  {
    id: 'Organization',
    name: 'Organization',
  },
];

export const PACING_OPTIONS = [
  {
    id: 'Green',
    name: 'Normal',
  },
  {
    id: 'Yellow',
    name: 'Monitor',
  },
  {
    id: 'Red',
    name: 'At Risk',
  },
  {
    id: 'Optimizing',
    name: 'Optimizing',
  },
];

export const CAMPAIGN_TABS = {
  PERFORMANCE: 'PERFORMANCE',
  SPEND: 'SPEND',
};



export const ACCOUNT_TIER = {
  GENERAL: 'General',
  SILVER: 'Silver',
  GOLD: 'Gold',
  PLATINUM: 'Platinum',
  SAPPHIRE: 'Sapphire',
};

export const ACCOUNT_TIER_COLOR = {
  [ACCOUNT_TIER.GENERAL]: '#126A8A',
  [ACCOUNT_TIER.SILVER]: '#D5D5D5',
  [ACCOUNT_TIER.GOLD]: '#F1BA52',
  [ACCOUNT_TIER.PLATINUM]: '#1287CD',
  [ACCOUNT_TIER.SAPPHIRE]: '#B5D4E0',
};


export const ACCOUNT_TIER_OPTIONS = [
  {
    id: ACCOUNT_TIER.GENERAL,
    name: 'General',
  },
  {
    id: ACCOUNT_TIER.SILVER,
    name: 'Silver',
  },
  {
    id: ACCOUNT_TIER.GOLD,
    name: 'Gold',
  },
  {
    id: ACCOUNT_TIER.PLATINUM,
    name: 'Platinum',
  },
  {
    id: ACCOUNT_TIER.SAPPHIRE,
    name: 'Sapphire',
  },
];